'use client';

// `<MainnetGateMirror />` — writes the resolved `mainnet_enabled` gate
// value to a cookie so server-side middleware can branch on it.
//
// Resolution order:
//   1. DevToolkit override — read DIRECTLY from the Zustand store
//      (bypassing `getDevToolkitOverride`'s `accessGranted` gate). The
//      access gate is a soft UI guard, not a security boundary; for
//      the cookie write we trust localStorage state immediately so the
//      override takes effect on first paint, even before the DevToolkit
//      panel itself has mounted.
//   2. `isMainnetEnabled()` — falls through to the registry default
//      (false pre-launch). Picks up Statsig live values once the
//      analytics provider has initialised.
//
// Reactive: the Zustand selector subscribes to `overrides.mainnet_enabled`,
// so flipping the DevToolkit toggle re-renders this component, the
// resolved value updates, and the effect rewrites the cookie.
import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { useEffect } from 'react';
import { setCookie } from '@/lib/config/cookies';
import { MAINNET_GATE_COOKIE, MAINNET_GATE_COOKIE_MAX_AGE } from '@/lib/network/gate-cookie';
import { isMainnetEnabled } from '@/lib/network/mainnet-enabled';
import { useDevToolkitStore } from '@/stores/dev-toolkit';
export function MainnetGateMirror() {
  const $ = _c(5);
  const override = useDevToolkitStore(_temp);
  let t0;
  if ($[0] !== override) {
    t0 = override !== undefined ? override : isMainnetEnabled();
    $[0] = override;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const resolved = t0;
  let t1;
  let t2;
  if ($[2] !== resolved) {
    t1 = () => {
      setCookie(MAINNET_GATE_COOKIE, resolved ? "true" : "false", MAINNET_GATE_COOKIE_MAX_AGE);
    };
    t2 = [resolved];
    $[2] = resolved;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return null;
}
function _temp(s) {
  return s.overrides.mainnet_enabled;
}